export class Reseller {
    _id;
    name;
    title;
    active;
    deleted;
}
export class ResellerFilter {
    _id;
    name;
    title;
    active;
    deleted;
}
export class CreateReseller {
    name;
    title;
}
export class UpdateReseller {
    name;
    title;
    active;
    deleted;
}
